import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import history from 'app/routes/history';
import SectionGroup from 'app/components/general/SectionGroup';
import Button from 'app/components/general/Button';
import HeaderThin from 'app/components/layout/HeaderThin';
import InputGroupBlock from 'app/components/general/InputGroupBlock';

import csvImportTypes from 'app/utils/static/csvImportTypes';

interface IChooseImportTypeProps {
  appReady: boolean;
  actions: any;
  match: any;
  organisations: any;
  competitions: any;
  fixtureMatches: any;
  fixtureMatchImports: any;
  errors: any;
  changeFileContent: any;
}

interface IChooseImportTypeState {
  importType: any;
  competition: any;
}
export default class ChooseImportType extends React.Component<
  IChooseImportTypeProps,
  IChooseImportTypeState
> {
  static defaultProps: IChooseImportTypeProps = {
    appReady: false,
    actions: undefined,
    match: undefined,
    organisations: {},
    competitions: {},
    fixtureMatches: {},
    fixtureMatchImports: {},
    errors: undefined,
    changeFileContent: undefined,
  };

  state: IChooseImportTypeState = {
    importType: undefined,
    competition: undefined,
  };

  handleSelectImportType = (e) => {
    this.setState(() => ({
      importType: e,
    }));
  };

  handleCompetitionChange = (e): void => {
    if (e && e.id != null) {
      this.setState(() => ({
        competition: e,
      }));
      this.props.actions.selectCompetition(e.id);
    }
  }

  handleSubmit = () => {
    history.push(`/connections/${this.props.match.params.connectionId}/run/csv/${this.state.importType.id}`);
  }

  render(): React.ReactNode {
    return (
      <div>
        <div className="row">
          <div className="col">
            <HeaderThin
              divider
              breadcrumb="Connections"
              breadcrumbLink="/connections"
              title="Import CSV"
            />
          </div>
        </div>
        <div className="row">
          <div className="col col-12 col-lg-10 col-xl-8">
            <SectionGroup>
              <div className="row">
                <div className="col">
                  <div className="form-description">
                    Select what type of data that needs to be imported.
                  </div>
                </div>
              </div>
              <div className="row with-margin-top">
                <div className="col">
                  <InputGroupBlock
                    type="select"
                    name="organisation"
                    labelText="Competition"
                    placeholder="Sports organisation/league"
                    aria-label="Sports organisation/league"
                    inputGroupClassName="no-margin-bottom"
                    autoComplete="off"
                    value={this.state.competition}
                    options={
                      this.props.competitions.competitionsByIdInSelectFormat
                    }
                    onChange={this.handleCompetitionChange}
                  />
                </div>
              </div>
              <div className="row with-margin-top">
                <div className="col">
                  <InputGroupBlock
                    type="select"
                    labelText="Import Type"
                    name="importType"
                    placeholder="Import Type"
                    aria-label="Import Type"
                    autoComplete="off"
                    tabIndex="2"
                    value={this.state.importType}
                    options={csvImportTypes}
                    onChange={this.handleSelectImportType}
                  />
                </div>
              </div>

              <div
                className={classnames('row', {
                  'd-none': this.state.importType === undefined,
                })}
              >
                <div className="col btn-flex-group">
                  <div className="btn-flex-container">
                    <Button
                      className="btn-standard btn-1"
                      type="submit"
                      onClick={this.handleSubmit}
                    >
                      Continue
                    </Button>
                    <Button
                      onClick={() => history.push('/connections')}
                      className="btn-standard btn-2"
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              </div>
            </SectionGroup>
          </div>
        </div>

      </div>
    );
  }
}
